import React from 'react';
import styles from './BrandsMessage.module.css';
import { formatMessage } from '../../../../utils/formatMessage';

export interface BrandsMessageProps {
  logo?: React.ReactNode; // Logo can be a component or any valid HTML element
  title: string; // Title is a required string
  message: string; // Message is a string that can contain **bold** markers
  cta?: React.ReactNode; // CTA can be a component or any valid HTML element
}

const BrandsMessage: React.FC<BrandsMessageProps> = ({
  logo,
  title,
  message,
  cta,
}) => {
  return (
    <div
      role='article'
      aria-labelledby='brands-title'
      aria-describedby='brands-message'
      className={styles['brand-message']}
    >
      {/* Logo Section */}
      {logo && (
        <div role='img' aria-label='Logo'>
          {logo}
        </div>
      )}

      {/* Title Section */}
      <h1
        id='brands-title'
        tabIndex={0}
        className={styles['brand-message__info__title']}
      >
        {title}
      </h1>

      {/* Message Section */}
      <p
        id='brands-message'
        tabIndex={0}
        className={styles['brand-message__info__message']}
      >
        {formatMessage(message)}
      </p>

      {/* CTA Section */}
      {cta && <div>{cta}</div>}
    </div>
  );
};

BrandsMessage.displayName = 'BrandsMessage';

export default BrandsMessage;
